<template>
  <div >
    <div class="col-sm-12">
      <el-table class="table table-striped table-no-bordered table-hover"
                ref="historyTable"
                :data="items ? items : history"
                v-loading="paging"
                element-loading-spinner="qc-spinner"
                style="width: 100%"
                :row-class-name="rowClass"
                :cell-class-name="cellClass"
                highlight-current-row
                @current-change="selectVerification"
                tooltip-effect="light">
        <el-table-column :min-width="125" label="Date">
          <template slot-scope="props">
            <span>{{formatDate(props.row.recorded)}}</span>
          </template>
        </el-table-column>
        <el-table-column :min-width="180" :show-overflow-tooltip="true" label="Name">
          <template slot-scope="props">
            <span>{{props.row.fields.firstname}} {{props.row.fields.surname}}</span>
          </template>
        </el-table-column>
        <el-table-column :min-width="220" :show-overflow-tooltip="true" label="Institute / Organisation">
          <template slot-scope="props">
            <div v-if="$service.isEmp(props.row.instituteId)">
              <span>{{props.row.fields.employerName ? props.row.fields.employerName : props.row.instituteName}}</span>
            </div>
            <div v-else>
              <div v-if="props.row.instituteNames && props.row.instituteNames.length > 0">
                <div v-for="name in props.row.instituteNames">{{name}}</div>
              </div>
              <div v-else>{{props.row.instituteName}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="!$store.state.isIndividual" :min-width="120" :show-overflow-tooltip="true" label="Requested By"> <!--:label="requestAndRefLabel">-->
          <template slot-scope="props">
            <span>{{props.row.username}}</span><!--<br/>{{props.row.customerReference}}</span>-->
          </template>
        </el-table-column>
        <el-table-column
          :min-width="150"
          :show-overflow-tooltip="true" 
          fixed="right"
          align="center"
          label="Status">
          <template slot-scope="props">
            <span v-if="props.row.result == 'VERIFIED'" class="label label-wd label-plain text-success"><i class="fa fa-check text-success"></i>Verified</span>
            <span v-else-if="props.row.result == 'NOT_VERIFIED'" class="label label-wd label-plain text-danger"><i class="fa fa-times text-danger"></i>Not Verified</span>
            <span v-else-if="props.row.result == 'PENDING'" class="label label-wd label-plain"><i class="fa fa-clock-o"></i>Pending</span>
            <span v-else-if="props.row.result == 'REJECTED'" class="label label-wd label-plain"><i class="fa fa-exclamation"></i>Action Required</span>
            <span v-else-if="props.row.result == 'NOT_FOUND'" class="label label-wd label-plain"><i class="fa fa-exclamation"></i>Action Required</span>
            <span v-else-if="props.row.result == 'UNPAID'" class="label label-wd label-plain"><i class="fa fa-pencil"></i>Incomplete</span>
            <span v-else-if="props.row.result == 'AWAITING_CONSENT'" class="label label-wd label-plain"><i class="fa fa-pencil"></i>Incomplete</span>
            <span v-else-if="props.row.result == 'CANCELLED'" class="label label-wd label-plain"><i class="fa fa-times"></i>Cancelled</span>
            <span v-else-if="props.row.result == 'UNABLE'" class="label label-wd label-plain"><i class="fa fa-clock-o"></i>Delayed at Source</span>
            <span v-else-if="props.row.result == 'DELETED'" class="label label-wd label-plain"><i class="fa fa-times"></i>Deleted</span>
            <span v-else>{{props.row.result}}</span>
            <br v-if="props.row.shared"/>
            <span v-if="props.row.shared" class="label label-wd label-plain text-warning"><i class="fa fa-share-alt text-warning"></i>Shared</span>
            <br v-if="props.row.accreditationStatus"/>
            <span v-if="props.row.accreditationStatus == 'PENDING'" class="label label-wd label-plain"><i class="fa fa-search"></i>Accreditation <br/>Check Pending</span>
            <span v-if="props.row.accreditationStatus == 'ACCREDITED'" class="label label-wd label-plain text-success"><i class="fa fa-check text-success"></i>Acredited</span>
            <span v-if="props.row.accreditationStatus == 'NOT_ACCREDITED'" class="label label-wd label-plain text-danger"><i class="fa fa-times text-danger"></i>Not Accredited</span>
            <span v-if="props.row.accreditationStatus == 'CANCELLED'" class="label label-wd label-plain"><i class="fa fa-times"></i>Accreditation <br/>Check Cancelled</span>
            <span v-if="props.row.accreditationStatus == 'DELETED'" class="label label-wd label-plain"><i class="fa fa-times"></i>Accreditation <br/>Check Deleted</span>
          </template>
        </el-table-column>
        <slot name="actions" />
      </el-table>
    </div>
    <div v-if="showPagination" class="col-sm-6 pagination-info">
      <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
    </div>
    <div v-if="showPagination" class="col-sm-6">
      <p-pagination class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total">
      </p-pagination>
    </div>
  </div>
</template>
<script>

  import PPagination from 'src/components/Pagination.vue'

  import moment from 'moment'
  import _ from 'lodash'

  export default {
    name: "verification-history-table",
    components: {
      PPagination
    },
    props: {
      items: {type: Array, default: null},
      query: {type: String, default: ""},
      requestedBy: {type: String, default: null},
      customerReference: {type: String, default: null},
      results: {type: Array, default: () => {return []}},
      types: {type: Array, default: () => {return []}},
      dateRange: {type: Array, default: () => {return []}},
      size: {type: Number, default: 20},
      showPagination: {type: Boolean, default: true}
    },
    data () {
      return {
        result: null,
        highlight: null,
        history: null,
        paging: false,
        total: 0,
        pagination: {
          perPage: 20,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        internalResults: []
      }
    },
    mounted () {
      if(this.$route.query.highlight) {
        this.highlight = this.$route.query.highlight.split(",")
      }
      if(!this.items) {
        this.getHistory()
      }
    },
    activated () {
      if(this.$route.query.highlight) {
        this.highlight = this.$route.query.highlight.split(",")
      }
      if(!this.items) {
        this.getHistory()
      }
    },
    watch: {
      query: _.debounce(function  (value) {
        this.pagination.currentPage = 1
        this.getHistory()
      }, 500),
      customerReference: _.debounce(function  (value) {
        this.pagination.currentPage = 1
        this.getHistory()
      }, 500),
      requestedBy(value) {
        this.pagination.currentPage = 1
        this.getHistory()
      },
      results (value) {
        this.pagination.currentPage = 1
        this.getHistory()
      },
      types (value) {
        this.pagination.currentPage = 1
        this.getHistory()
      },
      dateRange (value) {
        this.pagination.currentPage = 1
        this.getHistory()
      },
      paginationCurrentPage (value) {
        this.getHistory()
      },
      paginationPerPag (value) {
        this.getHistory()
      }
    },
    computed: {
      paginationCurrentPage () {
        return this.pagination.currentPage
      },
      paginationPerPag () {
        return this.pagination.perPage
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      requestAndRefLabel () {
        var label = "Requested By"
        var toCheck = this.items ? this.items : this.history
        if(toCheck && toCheck.length > 0) {
          var includeRef = toCheck.some(check => check.customerReference)
          if(includeRef) {
            label += " & " + this.$store.getters.refLabel
          }
        }
        return label
      }
    },
    methods: {
      rowClass(row) {
        // if(this.highlight && this.highlight.includes("" + row.row.id)) {
        //   return 'danger-row'
        // }
        switch(row.row.result) {
          case 'REJECTED':
          case 'NOT_FOUND':
            return 'warning-row'
          default:
            return ''
        }
      },
      cellClass(row) {
        if(row.column.label === 'Status') {
          switch(row.row.result) {
            case 'REJECTED':
            case 'NOT_FOUND':
              return 'warning-cell'
            default:
              return ''
          }
        }
      },
      formatDate (timestamp) {
        var m = moment(timestamp)
        return m.format('DD MMM YYYY')
      },
      getHistory: _.debounce(function () {
        this.paging = true
        this.history = []
        let historyRequest = {
          page: this.pagination.currentPage - 1,
          size: this.size,
          query: this.query,
          requestedBy: this.requestedBy,
          customerReference: this.customerReference,
          results: this.results,
          types: this.types,
          fromDate: this.dateRange[0],
          toDate: this.dateRange[1],
        }
        this.$api.getVerificationHistory(historyRequest)
          .then(response => {
            this.history = response.data.content
            this.pagination.total = response.data.totalSize
            this.total = response.data.totalSize
            this.paging = false
          })
          .catch(error => {
            this.paging = false
          })
      }, 500),
      selectVerification (row, oldRow) {
        if(row) {
          this.$router.push('/verification/history/' + row.id)
        }
      }
    }
  }
</script>
<style>

</style>
